var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoatFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#003C71",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M1.5 53.5a8 8 0 0 0 8 8c3.036 0 5.645-1.711 7-4.202 1.355 2.491 3.964 4.202 7 4.202s5.645-1.711 7-4.202c1.355 2.491 3.964 4.202 7 4.202s5.645-1.711 7-4.202c1.355 2.491 3.964 4.202 7 4.202a8 8 0 0 0 8-8M25.5 7.5h10M25.5 16.5v-15h10v15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 37V19.5a3 3 0 0 1 3-3h30a3 3 0 0 1 3 3V37M30.5 26.5v24"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M10.5 52.5l-4-12 24-14 24 14-4 12M24.5 37.5v2M36.5 37.5v2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoatFront);
export default __webpack_public_path__ + "static/media/boat-front.f0d3fbc5cff41d575f9b69dd1b820829.svg";
export { ForwardRef as ReactComponent };